module.exports = __webpack_public_path__ + "assets/payment-success.svg?v=555985431ac8e6a769ecc3a74e09ec30";